import { ArrowRight } from 'lucide-react';

/**
 * "How it works" 3-step section on the landing page.
 */
export const LandingSteps = ({ t, steps }) => (
  <section className="py-24 bg-card/50 border-t border-border" data-testid="landing-steps">
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
      <div className="text-center mb-16">
        <h2 className="text-3xl sm:text-4xl font-black tracking-tight mb-4">{t('landing.howItWorks')}</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">{t('landing.howItWorksDesc')}</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {steps.map((item, index) => (
          <div key={item.num} className="relative">
            <div className="text-7xl font-black text-primary/75 mb-4">{item.num}</div>
            <h3 className="text-xl font-bold mb-2">{item.title}</h3>
            <p className="text-muted-foreground">{item.desc}</p>
            {index < 2 && (
              <div className="hidden md:block absolute top-8 right-0 translate-x-1/2">
                <ArrowRight className="w-6 h-6 text-muted-foreground/30" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);
